var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubjects(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:currentColor;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M52.45,28.8c0,6.75-0.04,13.49,0.03,20.24c0.02,1.64-0.6,2.53-2.1,3.18c-8.55,3.7-17.08,7.46-25.6,11.23 c-1.06,0.47-1.99,0.48-3.03-0.02c-2.86-1.38-5.73-2.72-8.61-4.04c-1.08-0.5-1.61-1.26-1.61-2.47c0.02-14.07,0.02-28.14,0-42.22 c0-1.16,0.5-1.92,1.5-2.4C21.37,8.36,29.7,4.4,38.06,0.49c1.75-0.82,3.1,0.09,3.37,2.03c0.06,0.41,0.44,0.9,0.8,1.11 c1.13,0.63,2.34,1.12,3.5,1.7c1.28,0.65,2.44,1.3,4,0.4c1.06-0.61,2.45,0.42,2.65,1.69c0.08,0.52,0.06,1.06,0.06,1.59 C52.45,15.6,52.45,22.2,52.45,28.8z M16.08,19.45c-0.07,0.27-0.11,0.36-0.11,0.45C15.97,31.56,15.96,43.21,16,54.87 c0,0.43,0.43,1.04,0.83,1.25c1.74,0.91,3.52,1.78,5.35,2.5c0.66,0.26,1.61,0.31,2.25,0.03c7.46-3.2,14.87-6.5,22.32-9.72 c0.99-0.43,1.31-0.95,1.3-2.03C48,35.59,48.01,24.27,48.01,12.95c0-0.47,0-0.93,0-1.55c-0.55,0.22-0.94,0.36-1.32,0.54 c-7.44,3.35-14.89,6.7-22.32,10.08c-1.2,0.55-2.26,0.56-3.42-0.08C19.39,21.08,17.79,20.32,16.08,19.45z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M37.34,38.6c-1.97,0-3.95,0.05-5.91-0.04c-0.44-0.02-0.85-0.51-1.28-0.78c0.43-0.29,0.86-0.82,1.29-0.82 c3.94-0.06,7.89-0.06,11.83,0c0.43,0.01,0.85,0.55,1.27,0.84c-0.43,0.27-0.84,0.74-1.28,0.76C41.29,38.64,39.31,38.6,37.34,38.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M37.43,43.73c1.97,0,3.94-0.04,5.91,0.03c0.41,0.02,0.8,0.46,1.2,0.7c-0.41,0.31-0.81,0.88-1.22,0.88 c-3.98,0.07-7.97,0.07-11.96,0c-0.41-0.01-0.81-0.58-1.21-0.9c0.41-0.24,0.82-0.67,1.24-0.69C33.39,43.69,35.41,43.73,37.43,43.73z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M37.19,31.9c-1.88,0-3.76,0.06-5.63-0.04c-0.48-0.03-0.94-0.55-1.41-0.84c0.48-0.29,0.95-0.81,1.43-0.82 c3.85-0.07,7.71-0.07,11.56,0c0.47,0.01,0.94,0.55,1.4,0.84c-0.47,0.29-0.93,0.8-1.42,0.82C41.14,31.95,39.17,31.9,37.19,31.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.94,30.95c0-1.86,0.05-1.9,1.97-1.89c1.79,0.01,1.89,0.11,1.89,2.02c0,1.76-0.16,1.9-2.02,1.9 C23.99,32.97,23.94,32.92,23.94,30.95z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.94,37.71c0.01-1.82,0.03-1.84,2-1.83c1.82,0.01,1.86,0.05,1.85,2c-0.01,1.78-0.08,1.85-2.04,1.84 C23.95,39.71,23.94,39.7,23.94,37.71z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25.92,46.43c-1.96,0-1.97,0-1.97-1.85c0-1.97,0.02-1.99,1.85-1.99c1.93,0,2,0.07,2.01,1.88 C27.8,46.4,27.78,46.42,25.92,46.43z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubjects);
export default __webpack_public_path__ + "static/media/subjects.7f5de9f6e0869f44c85ad0a0eccee6c6.svg";
export { ForwardRef as ReactComponent };